<template>
  <div :class="{ 'system-message-item': true, 'no-shadow': type !== 'light' }" :style="{ background: type == 'light' ? '#FFFFFF' : '#F2F2F2'}">
    <div class="system-message-item__info">
      <div class="item__info-top">
        <div class="item__info-top__left">{{ itemInfo.Title }}</div>
        <div class="item__info-top__right">{{ itemInfo.CreateTime ? new Date(itemInfo.CreateTime).Format('yyyy/MM/dd hh:mm:ss') : ''}}</div>
      </div>
      <div class="item__info-bottom">
        {{ itemInfo.Content }}
      </div>
    </div>
    <div class="system-message-item__icon">
      <i class="el-icon-arrow-right"></i>
    </div>
  </div>
</template>

<script>
import { post, fetch, Del, put } from "@/ask/axios";
export default {
  props: {
    type: {
      required: false,
      type: String,
      default: 'light' // light: 未读; dark: 已读
    },
    itemInfo: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    },
  },
  
}
</script>

<style lang="scss" scope>
.no-shadow {
  box-shadow: none;
}

.system-message-item  {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  margin-top: 8px;
  // width: 370px;
  box-sizing: border-box;
  background: #FFFFFF;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  border: 1px solid transparent;


  .system-message-item__info {
    flex: 1;
    .item__info-font {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 17px;
    }

    .item__info-top {
      display: flex;
      justify-content: space-between;

      .item__info-top__left {
        @extend .item__info-font;
        color: #333333;
      }

      .item__info-top__right {
        @extend .item__info-font;
        color: #AAAAAA;
      }
    }

    .item__info-bottom {
      margin-top: 8px;
      @extend .item__info-font;
      color: #777777;
    }
  }

  .system-message-item__icon {
    padding-left: 15px;
    display: flex;
    justify-content: center;
    align-items: center;

    i {
      display: block;
      font-size: 12px;
      color: #3D3D3D;
    }
  }
}

.system-message-item:hover {
  cursor: pointer;
  border: 1px solid #0C5EE4;

  .system-message-item__icon {
    i {
      color: #0C5EE4;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/backstageManagement/public/rightTopMessage/systemMessageItem.vue